/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" -- Legacy code: do not use as an example. */
import { TFunction } from 'next-i18next';

import { ExpanderLabels } from './index';

export const getExpanderLabel = ({
    t,
    truncateText,
    expanderLabels,
}: {
    t: TFunction;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    truncateText: boolean;
    expanderLabels?: ExpanderLabels;
}) => {
    const {
        seeMore = t('See more', {
            context: 'Truncated text',
        }),
        seeLess = t('See less', {
            context: 'Truncated text',
        }),
    } = expanderLabels || {};

    return truncateText ? seeMore : seeLess;
};
